import enDictionary from '../lang/en'

export default {
  customer: 'TEST',
  debug: false,
  vmTarget: 'body',
  defaultSiteId: 'Member',
  newWorkflowAction: 'internal',
  overrideNewWorkFlowAction: false,
  endpoints: {
    newWorkflow: '/new',
    escape: '/escape',
    submit: '/submit',
    autocomplete: '/autocomplete',
    login: '/login',
    logout: '/logout',
    interrupt: '/interrupt'
  },
  appearance: {
    display: 'tabular',
    alerts: 'toast'
  },
  container: 'modal',
  http: {
    root: 'http://cygnet-member-demo.aptdev.net/comms',
    timeout: 4000
  },
  wysiwyg: {
    hint: 'Highlight some text or click in the box to begin editing',
    config: {
      imageDragging: true,
      placeholder: false,
      toolbar: {
        updateOnEmptySelection: true,
        standardizeSelectionStart: false,
        allowMultiParagraphSelection: true,
        static: true,
        sticky: true,
        buttons: ['removeFormat', 'bold', 'italic', 'underline', 'strikethrough', 'anchor', 'h1', 'h2', 'h3', 'unorderedlist', 'justifyLeft', 'justifyCenter', 'justifyRight'],
        firstButtonClass: 'medium-editor-button-first',
        lastButtonClass: 'medium-editor-button-last'
      }
    }
  },
  language: 'en',
  lang: {
    en: enDictionary
  }
}



// WEBPACK FOOTER //
// ./src/config/init.js